import React, { useContext } from "react";
import { observer } from "mobx-react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import BetItem from "./item/BetItem";
import EmptyMyBetsMessage from "@features/my-bets/mobile/common/EmptyMyBetsMessage";
import PagerWrapper from "./PagerWrapper";

import { BetDetailsModal } from "../../bet-details-modal/BetDetailsModal";
import LoaderSpinner from "@components-shared/LoaderSpinner";

export default observer(function BetsList() {
	const myBetsStore = useContext(MyBetsStoreContext);

	if (!(myBetsStore instanceof MyBetsStore)) {
		return null;
	}

	if (
		myBetsStore.isLoading &&
		!myBetsStore.betDetailsModalStore.isModalOpen
	) {
		return <LoaderSpinner isLoading isMobile />;
	}

	if (myBetsStore.shouldShowEmptyState) {
		return <EmptyMyBetsMessage />;
	}

	return (
		<ErrorBoundaryWithPropagation componentName={"Mobile/BetsList.tsx"}>
			<BetDetailsModal store={myBetsStore.betDetailsModalStore} />
			<div className="section--filled__list">
				{myBetsStore.betsList.map(
					(bet) =>
						!bet.isRemoved && (
							<MyBetsBetContext.Provider key={bet.id} value={bet}>
								<BetItem />
							</MyBetsBetContext.Provider>
						)
				)}
			</div>
			<PagerWrapper />
		</ErrorBoundaryWithPropagation>
	);
});
